import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import { usersCollection, professionalsGeoCollection, postsCollection, auth } from '../firebaseConfig'
import pagseguro from './pagseguro'

Vue.use(Vuex)

const DEBUG = process.env.NODE_ENV === 'development'

auth.onAuthStateChanged(async user => {
  if (user) {
    await store.commit('setCurrentUser', user)

    await store.dispatch('fetchUserProfile')

    await store.dispatch('checkAdminStatus')

    state.userProfile.userType === 'professional'
      ? store.dispatch('setActiveDashboardSection', 'professionalProfileSection')
      : store.dispatch('setActiveDashboardSection', 'userProfileSection')

    usersCollection.doc(user.uid).onSnapshot(async doc => {
      DEBUG && console.log('onSnapshot Event:usersCollection')

      if (doc.exists) {
        DEBUG && console.log('Updating user profile state with firebase data...')
        store.commit('setUserProfile', doc.data())

        DEBUG && console.log('Updating premium status information...')
        store.commit('setPerformingRequest', true)
        await store.dispatch('fetchPremiumStatus', user.uid)
        store.commit('setPerformingRequest', false)
      }
    })

    professionalsGeoCollection.doc(user.uid).onSnapshot(doc => {
      doc.exists && store.commit('setProfessionalProfile', doc.data())
    })

    // realtime updates from our posts collection
    postsCollection.orderBy('createdOn', 'desc').onSnapshot(querySnapshot => {
      DEBUG && console.log('onSnapshot Event:postsCollection')
      // check if created by currentUser
      let createdByCurrentUser

      if (querySnapshot.docs.length) {
        createdByCurrentUser = store.state.currentUser.uid === querySnapshot.docChanges()[0].doc.data().userId
      }

      if (createdByCurrentUser) {
        const postsArray = []
        querySnapshot.forEach(doc => {
          const post = doc.data()
          post.id = doc.id
          doc.data().userId === store.state.currentUser.uid && postsArray.push(post)
        })
        store.commit('setPosts', postsArray)
      }
    })
  }
})

export const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    pagseguro
  }
})
